import React from 'react'
import BarGraph from '../chart/BarGraph'
import PieChart from '../chart/PieChart'
import warningIcon from "../../assets/icons/voyages/euadifference/warning.svg";


const EUADistribution = () => {
  return (
    <div style={{display:"flex", flexDirection:"column", height:"50vh"}}>
      {/* <div style={{height:"40%"}}>
      <PieChart/>
      </div> */}
      <div style={{height:"80%"}}>
      <BarGraph/>
      </div>
    </div>
  )
}

export default EUADistribution